import React from "react";
import mapServiceItem from "./mapServiceItem";
import ServiceGlyph from "./ServiceGlyph";

export default function ServiceCard({ item, layout }) {
    const card = mapServiceItem(item);

    if (layout === "media") {
        return (
            <article className="service-media-card">
                <img src={card.text} alt={card.title} />
                <div>
                    <span>{card.marker}</span>
                    <h3>{card.title}</h3>
                </div>
            </article>
        );
    }

    return (
        <article className={`service-card service-card-${layout || "default"}`}>
            <span className={`service-card-marker ${String(card.marker).startsWith("icon-") ? "is-svg" : ""}`}>
                <ServiceGlyph type={card.marker} />
            </span>
            <div className="service-card-copy">
                <h3>{card.title}</h3>
                {card.kicker ? <span className="service-card-kicker">{card.kicker}</span> : null}
                <p>{card.text}</p>
                {card.tags?.length ? (
                    <div className="service-mini-tags">
                        {card.tags.map((tag) => (
                            <span key={tag}>{tag}</span>
                        ))}
                    </div>
                ) : null}
                {card.features?.length ? (
                    <div className="service-feature-list">
                        {card.features.map((feature) => (
                            <span key={feature}>{feature}</span>
                        ))}
                    </div>
                ) : null}
            </div>
        </article>
    );
}
